module.exports = __webpack_public_path__ + "static/media/_kosovo.2937ddb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_kosovo.svg
// module id = 2332
// module chunks = 7